import { ForgotPassword } from '@pageComponents/ForgotPassword/ForgotPassword';
import React from 'react';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface RouteProps {}

const ForgotPasswordPage: React.FC<RouteProps> = () => <ForgotPassword />;

export default ForgotPasswordPage;
